<template>
  <v-dialog v-model="show" max-width="400px" :persistent="persistent">
    <v-card>
      <v-card-title style="word-break: normal !important; justify-content: center;">{{ modalTitle }}</v-card-title>
      <v-card-text class="text-center">{{ $t('location.timeSlotToDuplicate', { timeSlots: timeSlotToDuplicate.timeSlots }) }}</v-card-text>

      <v-container fluid class="mt-0 mb-3">
        <v-checkbox
          v-for="(item, index) in weekDays"
          v-bind:key="index"
          class="w-auto"
          dense
          hide-details
          v-model="selectedDays"
          :label="$t('location.' + index)"
          :value="index"
          :disabled="timeSlotToDuplicate.day === index"
        ></v-checkbox>
      </v-container>

      <v-card-actions class="pa-0">
        <v-btn
          :disabled='!selectedDays.length'
          class="ml-0"
          color="primary"
          style="width: 50%;"
          tile
          @click="$emit('yes', selectedDays)"
        >{{ $t('components.modal.btn.yes') }}
        </v-btn>
        <v-btn
          class="ml-0"
          color="secondary"
          style="width: 50%;"
          tile
          @click="$emit('no')"
        >{{ $t('components.modal.btn.no') }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { weekDays } from '../../helpers/helper'

  export default {
    name: 'duplicateTimeSlotDialog',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: undefined
      },
      text: {
        type: String,
        default: undefined
      },
      persistent: {
        type: Boolean,
        default: false
      },
      timeSlotToDuplicate: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        selectedDays: [],
        weekDays: weekDays()
      }
    },
    watch: {
      show(newVal) {
        if (!newVal) {
          this.selectedDays = []
        }
      }
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        }
      },
      modalTitle: function () {
        return this.title || this.$t('components.modalConfirmation.defaultTitle')
      }
    }
  }
</script>

<style scoped>
  .w-45 {
    width: 45%;
  }
</style>
